import { NAVIGATION_LINKS } from "../../constants/common"
export const OUR_CASES = [
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/our_cases_trynow.webp",
        header: "TryNow",
        desc: "Developed e-commerce solutions from scratch",
        link: NAVIGATION_LINKS.TRYNOW,
        text: [
            "TryNow is a try-before-you-buy software for shoppers and Shopify brands. TryNow converts the customer's living room into the fitting room and authorises the credit card, tracks the SKUs, and captures payment once the customer has decided what they are going to keep, enabling businesses to improve their sales and productivity.",
            "In March 2021, TryNow raised a $12M series A from Shine Capital, Craft. Ventures, SciFi VC, and the founders of PayPal and Plaid, among other investors. The startup already works with around 50 up-and-coming online retailers doing between $10 million and $100 million in revenues. The business grow six-fold in the last 2 years.",
        ],
    },
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/our_cases_quarkworks.webp",
        header: "Quarkworks",
        desc: "Developed 4 powerful products for a budding startup",
        link: NAVIGATION_LINKS.QUARKWORKS,
        text: [
            "QuarkWorks is a software engineering and digital product design firm. They partner with startups and enterprise companies that are working on new products and features. They specialize in native mobile apps, web dev, e-commerce, UI/UX design, branding, and more!",
            "Whether your business is established or is a budding startup, Quarkworks work where you are to bring your vision into reality.",
        ],
    },
    {
        image: "https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/our_cases_orbit.webp",
        header: "Orbit",
        desc: "Developed recruitment platform for freelance recruiters",
        link: NAVIGATION_LINKS.ORBIT,
        text: [
            "Orbit is a recruitment platform designed for freelance recruiters. The system enables companies to post job vacancies which are then accessed by recruiters. Recruiters, in turn, identify and work with potential candidates for job vacancies.",
            "Once a candidate is approved by the recruiter, the candidate moves to the company's internal hiring process. Upon successful candidate approval by the company, the recruiter receives a bonus for their work.",
        ],
    },
]
